import axios from '@/plugins/axios'

const getFormTemplates = (params) => axios.get('/form-template', { params })
const getFormTemplate = (id) => axios.get(`/form-template/${id}`)
const createFormTemplate = (data) => axios.post('/form-template', data)
const updateFormTemplate = (id, data) => axios.put(`/form-template/${id}`, data)
const publishFormTemplate = (id) => axios.post(`/form-template/${id}/publish`)
const archiveFormTemplate = (id) => axios.post(`/form-template/${id}/archive`)
const duplicateFormTemplate = (id) => axios.post(`/form-template/${id}/duplicate`)
const deleteFormTemplate = (id) => axios.delete(`/form-template/${id}`)
const getTemplateServices = (id) => axios.get(`/form-template/${id}/services`)
const updateTemplateServices = (id, serviceIds) => axios.put(`/form-template/${id}/services`, { serviceIds })
const getServiceFormTemplate = (serviceId) => axios.get(`/service/${serviceId}/form-template`)

export {
  getFormTemplates,
  getFormTemplate,
  createFormTemplate,
  updateFormTemplate,
  publishFormTemplate,
  archiveFormTemplate,
  duplicateFormTemplate,
  deleteFormTemplate,
  getTemplateServices,
  updateTemplateServices,
  getServiceFormTemplate
}
